import * as yup from 'yup';
import useFetchMataData from '../../../../../../Components/Hooks/useFetchMataData';
import { Modal, notification } from 'antd';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { CancelButton, SubmitButton } from '../../../../../../Components/Utils/Buttons';
import { NuInput, NuSelect, NuTextArea } from '../../../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../../../Components/Utils/Select';
import UseCatSubCatDropDown from '../../../../../../Components/Hooks/useCategoryDropDown';

function MultiEditOthers({open,onCancel,getData,seletedIds,projectId}) {
    const {value:Category ,getData:refOthersCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'OthersCategory')
  const {value:Division ,getData:refOtherDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'OtherDivision')
  const {value:Unit ,getData:refOtherUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
    //   console.log("finding",estiId);
    // const {value:Unit} = useFetchMataData(`/Metadata/unit`)
    const [api, contextHolder] = notification.useNotification();
    const [isLoading,setIsLoading] = useState(false);
   const [createNew, setCreateNew] = useState({
      
      activity: "",
      category: "",
      division: "",
      amount: "",
      unit: "",
      quantity: "",
      comments: ""
    });
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
      //   name:yup.string().required("Tittle is Requried")
      }),
      onSubmit: (value,{resetForm}) => {    
        setIsLoading(true);
        const values = {
          ...value,
          ids: seletedIds
        }
        axiosInstance
        .put(`/pro_manpower/multi-update`, values)
          .then((res) => {
            console.log(res);
            if (res.status === 201 || res.data.status == true) {
              setIsLoading(false);
              getData();
              resetForm();
              api.success({
                message: `Material Multi Item Edit successfully`,
                description: res?.data?.msg || "Added In Tittle",
                placement: "bottomRight",
              });
              onCancel();
            } else {
              api.error({
                message: `Material Multi Item Edit failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
              setIsLoading(false);
            }
          })
          .catch((err) => {
            api.error({
              message: `Material Multi Item Edit failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          });
      },
    });

    const { category: itemsCategory, subCategory: itemsSubCategory } =
  UseCatSubCatDropDown
  (
    "/category/ItemCategory",
    "ItemCategory",
    formik?.values?.category
  );
  
    useEffect(() => {
      const totalPrice = formik?.values?.actual_quantity * formik?.values?.actual_Price
      formik.setFieldValue("totalPrice", totalPrice);
    }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
  
    return (
      <>
      {contextHolder}
      <Modal
        open={open}
        title={"Multi Edit Others"}
        width={"50%"}
        className="my-modal"
        centered
        footer={[]}
        onCancel={onCancel}
      >
      <form onSubmit={formik.handleSubmit} >
        <div className=" w-full flex flex-wrap">
           {/* <NuInputText
                label="Item Name"
                placeholder="Item Name"
                formik={formik}
                name="item"
                width="w-full"
            /> */}
            <NuInput
                           type="text"

                 label="Activity"
                 formik={formik}
                 placeholder="Activity"
                 name="activity"
                 width="w-full md:w-1/3"
                 isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Category"
                  Options={itemsCategory||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="category"
                  width="w-full md:w-1/3"
                  // getFunc={refOthersCategory}
                  displayProperty={"Category"}
                  propertyName={"OthersCategory"}
                  isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Division"
                  Options={Division||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="division"
                  width="w-full md:w-1/3"
                  getFunc={refOtherDivision}
                  displayProperty={"Division"}
                  propertyName={"OtherDivision"}
                  isRequired={true}
                /> 

              

                <FormikSelectTwo
                  label="Unit"
                  Options={Unit||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="unit"
                  width="w-full md:w-1/3"
                  getFunc={refOtherUnit}
                  displayProperty={"Unit"}
                  propertyName={"OtherUnit"}
                  isRequired={true}
                />
 
                <NuInput
                             type="number"

                 label="Quantity"
                 formik={formik}
                 placeholder="Quantity"
                 name="quantity"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />    
                  <NuInput
                             type="number"

                 label="Amount"
                 formik={formik}
                 placeholder="Amount"
                 name="amount"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />  

                <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  width="w-full md:w-2/3"
                />
              <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                <CancelButton handleClick={onCancel} />
                <SubmitButton isLoading={isLoading} />
              </div>
        </div>
        </form>
      </Modal>
      </>
    )
    }
    
    export default MultiEditOthers;